function hasNestedValue (fieldName, dataItem, { checkNull = false, checkUndefined = false } = {}) {
  if (!fieldName) {
    return false
  }
  const path = fieldName.replace(/([^.])\[(\d+)\]/g, '$1.$2').replace(/\[(\d+)\]/, '$1').split('.')
  let parent = dataItem
  for (let i = 0; i < path.length; i++) {
    const key = path[i]
    if (parent === null || parent === undefined) {
      return false
    }
    if (!Object.hasOwnProperty.call(parent, key)) {
      return false
    }
    parent = parent[key]
  }
  return !((checkNull && parent === null) || (checkUndefined && parent === undefined))
}

export default hasNestedValue
